<template>

    <div id="student">
        <el-tabs
            type="card"
            @tab-click="setIndex"
        >
            <el-row
                type="flex"
                justify="start"
                :gutter="20"
                style="margin-bottom:20px;"
            >
                <el-col class="widthauto">
                    <el-select
                        v-model="searchForm.termId"
                        filterable
                        clearable
                        placeholder="学期"
                        @change="search"
                    >
                        <el-option
                            v-for="item in dictionary.termData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col class="widthauto">
                    <el-select
                        v-model="statusd"
                        filterable
                        clearable
                        placeholder="状态"
                        @change="searchs"
                    >
                        <el-option
                            v-for="item in statusD"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-col>
                <el-col class="widthauto">
                    <el-select
                        v-model="searchForm.affirmed"
                        filterable
                        clearable
                        placeholder="缴费状态"
                        @change="search"
                    >
                        <el-option
                            v-for="item in  dictionary.feeData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-tab-pane label="已报名班级">
                <el-table
                    :data="RecordData"
                    ref="CourseData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    v-loading="loading"
                    element-loading-text="数据加载中，请稍等..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <el-table-column
                        prop="className"
                        label="班级"
                        show-overflow-tooltip
                        min-width="100"
                    >
                        <template slot-scope="scope">
                            <a style="font-size:16px;">{{scope.row.className}}</a> <span
                                v-if="scope.row.isShortTraining"
                                style="color:#e4393c;font-size:14px;"
                            >(短训班)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="periodName"
                        label="上课教室时间"
                        min-width="160"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.isShortTraining">
                                <el-tooltip
                                    :content="scope.row.$customClassName"
                                    placement="right"
                                >
                                    <span>{{scope.row.shortTrainingStart}}到{{scope.row.shortTrainingEnd}}</span>
                                </el-tooltip>
                            </span>
                            <span v-else>{{scope.row.$customClassName}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="classRoomName" label="教室" show-overflow-tooltip></el-table-column> -->
                    <el-table-column
                        prop="teacherName"
                        label="教师"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="fee"
                        label="学费/元"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="materialCost"
                        label="材料费/元"
                        show-overflow-tooltip
                        v-if="ismast"
                    ></el-table-column>
                    <el-table-column
                        prop="entryFee"
                        label="报名费/元"
                        show-overflow-tooltip
                        v-if="isbm"
                    ></el-table-column>

                    <el-table-column
                        prop="type"
                        label="缴费状态"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.affirmed=='1'">已缴费</span>
                            <span v-if="scope.row.affirmed=='0'">未缴费</span>
                            <span v-if="scope.row.affirmed=='2'">无需缴费</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.status=='0'">已退班</span>
                            <span v-if="scope.row.status=='1'">正常</span>
                            <span v-if="scope.row.status=='4'">休学</span>
                            <span v-if="scope.row.status=='3'">转班</span>
                            <span v-if="scope.row.status=='2'">已插班</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="操作"
                        width="150px"
                    >
                        <template slot-scope="scope">

                            <el-button
                                @click="gopay(scope.row)"
                                type="warning"
                                v-if="scope.row.affirmed=='0'&& scope.row.status!='0'&& scope.row.status!='4'"
                            >前去缴费</el-button>
                            <el-button
                                @click="queryLessonsplandetail(scope.row)"
                                v-if="scope.row.affirmed!='0'&& scope.row.status!='0'&& scope.row.status!='4'"
                            >查看教学计划</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="wrap_footer clearfix">

                    <div class="right">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[10, 15, 20, 25]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                            background
                        ></el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="教学计划详情"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            @close="closeedit"
            width="60%"
        >
            <el-table
                max-height="500"
                :data="planData"
                ref="schoolDate"
                tooltip-effect="dark"
                style="width: 100%"
            >
                <el-table-column
                    prop="schoolDate"
                    label="上课日期"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="weekname"
                    label="星期"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="timePeriodname"
                    label="时段"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.timePeriod">
                            {{scope.row.timePeriod.startSchoolTime}}-{{scope.row.timePeriod.endSchoolTime}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="授课内容"
                    show-overflow-tooltip
                ></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "myclass",

    data() {
        return {
            statusd: "",
            statusD: [
                {
                    name: "已退班",
                    id: "0",
                },
                {
                    name: "正常",
                    id: "1",
                },
                {
                    name: "已插班",
                    id: "2",
                },
                {
                    name: "转班",
                    id: "3",
                },
                {
                    name: "休学",
                    id: "4",
                },
            ],
            loading: false,
            dialogVisible: false,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                className: "",
                termId: "",
                affirmed: "",
                status: [],
                studentId: "",
                pageIndex: "1",
                pageSize: "10",
            },
            planData: [],
            tabindex: "0",
            RecordData: [],
            ismast: false,
            isbm: false,
            query: {
                type: "1",
                campusId: "",
                scName: "",
                specialtyId: "",
                planType: "1",
                courseId: "",
                week: "",
                newFlag: "",
                pageIndex: 1,
                pageSize: 10,
            },
            mainData: [],
            classdata: [],
            dictionary: {
                termData: [],
                feeData: [
                    {
                        id: "0",
                        name: "未缴费",
                    },
                    {
                        id: "1",
                        name: "已缴费",
                    },
                    {
                        id: "2",
                        name: "无需缴费",
                    },
                ],
            },
        };
    },
    created() {
        this.$global.activeMenu = "3-1"; //不激活左侧
    },
    async mounted() {
        let me = this;
        me.statusd = "";
        let userinfo = window.sessionStorage.getItem("userinfo");
        userinfo = JSON.parse(userinfo);
        me.searchForm.studentId = userinfo.id;
        await me.queryNowTerm();
        await me.queryClassStudent();
        await me.getDictionary();
    },
    methods: {
        // 处理每页显示数量
        handleSizeChange(val) {
            this.searchForm.pageSize = val;
            this.queryClassStudent();
            // this.select();
        },
        // 处理翻页
        handleCurrentChange(val) {
            this.searchForm.pageIndex = val;
            this.queryClassStudent();
            // this.select();
        },
        async queryLessonsplandetail(row) {
            let me = this;
            let param = {
                classStudentId: row.id,
            };
            let res = await me.$userService.queryLessonsplandetail(param);
            if (res && res["success"]) {
                me.dialogVisible = true;
                me.planData = res.content.lessonsplandetails;
            }
        },
        search() {
            let me = this;
            me.searchForm.pageIndex = 1;
            this.queryClassStudent();
        },
        async searchs() {
            let me = this;
            me.searchForm.pageIndex = 1;
            me.searchForm.pageSize = 10;
            me.searchForm.status = [];
            me.searchForm.status.push(me.statusd);
            await me.queryClassStudent();
        },
        async gopay(row) {
            let me = this;
            if (row.submitOrder) {
                me.$router.push({ name: "Order" });
            } else {
                me.$router.push({ name: "Pay" });
            }
        },
        async select() {
            let me = this;
            let param = me.query;
            let temData = [];
            let res = await me.$userService.select(param);
            if (res && res["success"]) {
                me.searchForm.termId = res.content.term.id;
                await me.queryClassStudent();
            }
        },
        async queryNowTerm() {
            let me = this;
            let res = await me.$team.queryNowTerm();
            if (res && res["success"] && res.content) {
                me.searchForm.termId = res.content.id;
            }
        },
        async queryClassStudent() {
            let me = this;
            let param = me.searchForm;
            me.ismast = false;
            me.isbm = false;
            let res = await me.$team.queryClassStudent(param);
            if (res && res["success"]) {
                res.content.records.forEach(function (item, index) {
                    if (item.materialCost) {
                        me.ismast = true;
                    }
                    if (item.entryFee) {
                        me.isbm = true;
                    }
                    try {
                        const classRoomNames = item.classRoomNames.split(",");
                        const periodName = item.periodName.split(",");
                        let customClassName = "";
                        classRoomNames.forEach((item, index) => {
                            customClassName +=
                                classRoomNames[index] +
                                "：" +
                                periodName[index] +
                                (classRoomNames.length === index + 1
                                    ? ""
                                    : "；");
                        });
                        item.$customClassName = customClassName;
                    } catch (e) {
                        item.$customClassName = "";
                    }
                });

                me.RecordData = res.content.records;
                me.total = res.content.total;
            }
        },
        closeedit() {
            this.dialogVisible = false;
        },
        showdetails() {
            this.dialogVisible = true;
        },

        setIndex(e) {
            let me = this;
            me.tabindex = e.index;
        },
        async getDictionary() {
            let me = this;
            let param = {
                pageIndex: 1,
                pageSize: 10,
            };
            //  查询学期信息
            let term = await me.$recruitService.queryTerm(param);
            if (term && term.success) {
                me.dictionary.termData = term.content.records;
            }

            //  let fee = await me.$userService.queryCodeInfoByCode(
            //   "lndx_classgroupstudent_affirmed"
            // );
            // if (fee && fee.success) {
            //   me.dictionary.feeData = fee.content.records;
            // }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#student .el-tabs__content {
    padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/myclass/myclass.vue